import { Box, BoxProps, ComponentStyleConfig, Select, SelectProps, SystemStyleObject } from '@chakra-ui/react';
import { IOption } from 'types';

export type ListBoxProps = SelectProps & {
  containerProps?: BoxProps;
  options: IOption[];
  styles?: SystemStyleObject;
};

const baseStyle = {
  icon: {
    visibility: 'hidden',
  },
};

const fieldBaseStyle = {
  borderRadius: 0,
  h: 'auto',
  py: 3,
};

const ListBoxStyles: ComponentStyleConfig = {
  variants: {
    filled: {
      ...baseStyle,
      field: {
        ...fieldBaseStyle,
        border: 'none',
        backgroundColor: 'gray.100',
        _hover: {
          backgroundColor: 'gray.100',
          boxShadow: 'none',
          border: 'none',
        },
        _focus: {
          backgroundColor: 'gray.100',
          boxShadow: 'none',
          border: 'none',
        },
      },
    },
    outline: {
      ...baseStyle,
      field: {
        ...fieldBaseStyle,
      },
    },
  },
};

const ListBox = ({ containerProps, options, variant, styles, ...props }: ListBoxProps) => {
  const containerStyles = {
    'select option': {
      backgroundColor: variant === 'filled' ? 'gray.100' : 'transparent',
    },
    'option:checked, option:focus, option:active': {
      color: 'white',
      background:
        'var(--chakra-colors-primaryThemeColour-400) linear-gradient(0deg, var(--chakra-colors-primaryThemeColour-400) 0%, var(--chakra-colors-primaryThemeColour-400) 100%)',
    },
    ...styles,
  };
  const renderOptions = options.map(({ value, label }) => (
    <option data-testid="list-box-option" key={value} value={value}>
      {label}
    </option>
  ));
  return (
    <Box {...containerProps} __css={{ ...containerStyles, ...(containerProps?.__css ?? {}) }}>
      <Select variant={variant} multiple {...props}>
        {renderOptions}
      </Select>
    </Box>
  );
};

export { ListBox, ListBoxStyles };
